export const DEFENSE_ATTORNEY_TYPE_ID = 2;
export const INSURANCE_ATTORNEY_TYPE_ID = 5;

export const PLAINTIFF_ATTORNEY_TYPE = {
  field: 'plaintiff_attorney',
  name: 'Plaintiff Attorney',
  id: 1,
};

export const MD_REVIEW_NAME = 'MD Review';
export const MSA_REDUCTION__REVIEWNAME = 'MSA Reduction Review';
export const QA_REVIEW_NAME = 'QA Review';

export const LIST_TYPE_USER_BY_A_LA_CARTE = [
  {
    name: MD_REVIEW_NAME,
    description: 'Pricing Varies Based on Specialty',
    toltip:
      "Specific role type to assign cases to contractors or partners of your choice, with limited visibility and accessibility to your portal, for review, comment, and suggestions. Designed for those who regularly work with MD professionals. Create the user within your system after payment completion. You can always add these later!",
  },
  {
    name: MSA_REDUCTION__REVIEWNAME,
    description: 'Pricing Varies Based on Specialty',
    toltip:
      "Specific role type to assign cases to contractors or partners of your choice, with limited visibility and accessibility to your portal, for review, comment, and suggestions. Designed for those who regularly work with Reduction specialists. Create the user within your system after payment completion. You can always add these later!",
  },
  {
    name: QA_REVIEW_NAME,
    description: 'Pricing Varies Based on Specialty',
    toltip:
      "Specific role type to assign cases to contractors or partners of your choice, with limited visibility and accessibility to your portal, for review, comment, and suggestions. Designed for those who regularly work with Quality Assurance or Internal Review specialists. Create the user within your system after payment completion. You can always add these later!",
  },
];

export const LIMIT_REVIEWER_5 = {
  price: 50,
  limit: 5,
};

export const LIMIT_REVIEWER_10 = {
  price: 100,
  limit: 10,
};
export const LIMIT_REVIEWER_15 = {
  price: 150,
  limit: 15,
};

export const LIST_COUNT_TYPE_REVIEWER = [
  {
    label: '1 to 5',
    value: LIMIT_REVIEWER_5.limit,
    price: LIMIT_REVIEWER_5.price,
  },
  {
    label: '6 to 10',
    value: LIMIT_REVIEWER_10.limit,
    price: LIMIT_REVIEWER_10.price,
  },
  {
    label: '11 to 15',
    value: LIMIT_REVIEWER_15.limit,
    price: LIMIT_REVIEWER_15.price,
  },
];
